import { memo } from 'react';

import { EmojiIcon } from '@air/next-icons';

import { NOTIFICATIONS_NONE } from '~/constants/testIDs';

export const NotificationEmpty = memo(() => {
  return (
    <div
      className="flex h-full min-h-[400px] flex-col items-center ui2:justify-center px-6 pt-[20%] ui2:pt-0"
      data-testid={NOTIFICATIONS_NONE}
    >
      <EmojiIcon className="mb-4 size-10 text-grey-7" />
      <p className="mb-4 font-medium text-20 text-grey-10">You’re all caught up</p>
      <p className="max-w-[430px] text-center text-14 text-grey-9">
        You’ll be notified here for @mentions, updates to boards that you follow, and any share links you’ve created.
      </p>
    </div>
  );
});

NotificationEmpty.displayName = 'NotificationEmpty';
